<div class="element-row" style="position: absolute; top: -33px; right: 109px;">
  <label aria-label="単ページ表示" data-microtip-position="bottom" role="tooltip">
    <button class="icon-button {{clsSinglePage}}" id="btn_SinglePage" forcedEnabledMode="true" [tabindex]="-1"
      (click)="eventSinglePage_CLICKHandler()">
      <img src="./assets/icons/KYMW14/singlepage.png">
    </button>
  </label>
  <label aria-label="見開き表示" data-microtip-position="bottom" role="tooltip">
    <button class="icon-button {{clsDoublePage}}" id="btn_DoublePage" forcedEnabledMode="true" [tabindex]="-1"
      (click)="eventDoublePage_CLICKHandler()">
      <img src="./assets/icons/KYMW14/doublepage.png">
    </button>
  </label>
  <label aria-label="画像表示" data-microtip-position="bottom" role="tooltip">
    <button class="icon-button {{clsImageVisible}}" id="btn_KomaImageVisible" #btn_KomaImageVisible
      forcedEnabledMode="true" [tabindex]="-1"
      (click)="eventkomaImageVisible_CLICKHandler();eventBtnKomaImageVisible_CLICKHandler()">
      <img src="./assets/icons/KYMW14/imageshow.png">
    </button>
  </label>
  <label aria-label="文字情報表示" data-microtip-position="bottom" role="tooltip">
    <button class="icon-button {{clsTextVisible}}" id="btn_KomaTextVisible" #btn_KomaTextVisible
      forcedEnabledMode="true" [tabindex]="-1"
      (click)="eventKomaTextVisible_CLICKHandler();eventBtnKomaTextVisible_CLICKHandler()">
      <img src="./assets/icons/KYMW14/textshow.png">
    </button>
  </label>
</div>
<div class="contents-area">
  <div class="header-container">
    <div class="block-row header">
      <div class="element-column" style="width:100%;">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title" style="width:80px;">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txi_OrderCode" #txi_OrderCode [subid]="'txi_OrderCode'"
                [catalogIDField]="txi_DelivCatalog" [registCycleField]="txi_RegistCycle" [forcedEnabledMode]="'true'"
                [tabindex]="0" [autofocus]="true"
                (input)="bindSelectedOrderCode_CHANGEHandler(txi_OrderCode.selectedOrderCode)">
              </app-order-code-text-input>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <div class="element-row">
                <input type="text" id="txi_DelivCatalog" #txi_DelivCatalog class="deliv-catalog" readonly
                  plessInputTextSub [restrict]="'[ -￮]'" />
                <input type="text" id="txi_RegistCycle" #txi_RegistCycle style="width:80px;" readonly plessInputTextSub
                  [restrict]="'[ -￮]'" />
              </div>
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">受付終了受注コード</label>
            <div class="list-input-content">
              <input type="text" id="txi_EndOrderCode" class="deliv-catalog" readonly
                [(ngModel)]="cmb_Medium.selectedReceiptEOrderCode" plessInputTextSub [restrict]="'[ -￮]'" />
            </div>
          </div>

          <div class="column-list">
            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="txi_DelivCatalog0" readonly
                [(ngModel)]="cmb_Medium.selectedReceiptECatalogId" plessInputTextSub [restrict]="'[ -￮]'" />
            </div>
          </div>
        </div>

        <div class="layout_balance">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title" style="width:80px;">媒体</label>
              <div class="list-input-content">
                <app-kymw1400-koma-medium-combo-box id="cmb_Medium" #cmb_Medium [subid]="'cmb_Medium'"
                  [orderCodeMediumeTypeClear]="txi_OrderCode.selectedOrderCode" [forcedEnabledMode]="'true'"
                  [tabindex]="0" [width]="225" (change)="eventCmbMedium_CHANGEHandler()">
                </app-kymw1400-koma-medium-combo-box>
              </div>
            </div>

            <div class="column-list">
              <label class="list-input-title">フェーズ</label>
              <div class="list-input-content">
                <input type="text" id="txi_Phase" readonly [(ngModel)]="cmb_Medium.selectedProgressWorkNumName"
                  plessInputTextSub [restrict]="'[ -￮]'" style="width: 27rem;" />
              </div>
            </div>
          </div>

          <div class="tool-buttons element-row">
            <label aria-label="印刷" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button" id="btn_PagePrint" #btn_PagePrint forcedEnabledMode="true" [tabindex]="-1"
                (click)="eventBtnPagePrint_CLICKHandler()">
                <img src="./assets/icons/KYMW14/print.png">
              </button>
            </label>

            <label aria-label="コマ追加" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button" id="btn_AddEmptyKoma" #btn_AddEmptyKoma forcedEnabledMode="true"
                [tabindex]="-1" [disabled]="kymw1400Model.disabledAddEmptyKomaFlg"
                (click)="eventAddEmptyKoma_CLICKHandler()">
                <img src="{{kymw1400Model.srcAddKoma}}">
              </button>
            </label>

            <label aria-label="コマ削除" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button" id="btn_DeleteKoma" #btn_DeleteKoma forcedEnabledMode="true" [tabindex]="-1"
                [disabled]="kymw1400Model.disabledDeleteKomaFlg" (click)="eventDeleteKoma_CLICKHandler()">
                <img src="{{kymw1400Model.srcDelKoma}}">
              </button>
            </label>

            <label aria-label="全コマ削除" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button" id="btn_DeleteAllKoma" #btn_DeleteAllKoma forcedEnabledMode="true"
                [tabindex]="-1" [disabled]="kymw1400Model.disabledDeleteAllKomaFlg"
                (click)="eventDeleteAllKoma_CLICKHandler()">
                <img src="{{kymw1400Model.srcDelAllKoma}}">
              </button>
            </label>

            <label aria-label="掲載候補リスト" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button {{clsCandidateGoods}}" id="btn_CandidateGoods" #btn_CandidateGoods
                forcedEnabledMode="true" [tabindex]="0" (click)="eventCandidateGoods_CLICKHandler()">
                <img src="./assets/icons/KYMW14/candidategoods.png">
              </button>
            </label>

            <label aria-label="商品情報" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button {{clsGoodsInfo}}" id="btn_GoodsInfo" #btn_GoodsInfo forcedEnabledMode="true"
                [tabindex]="-1" (click)="eventGoodsInfo_CLICKHandler()">
                <img src="./assets/icons/KYMW14/goodsinfo.png">
              </button>
            </label>

            <label aria-label="画像指示" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button {{clsImageDirection}}" id="btn_ImageDirection" #btn_ImageDirection
                forcedEnabledMode="true" [tabindex]="-1" (click)="eventImageDirection_CLICKHandler()">
                <img src="./assets/icons/KYMW14/imagedirection.png">
              </button>
            </label>

            <label aria-label="実績履歴" data-microtip-position="bottom" role="tooltip">
              <button class="icon-button {{clsHistory}}" id="btn_History" #btn_History forcedEnabledMode="true"
                [tabindex]="-1" [disabled]="kymw1400Model.disabledHistoryFlg" (click)="eventHistory_CLICKHandler()">
                <img src="./assets/icons/KYMW14/publishhistory.png">
              </button>
            </label>

            <label aria-label="マーク指示" data-microtip-position="left" role="tooltip">
              <button class="icon-button {{clsMarkDirection}}" id="btn_MarkDirection" #btn_MarkDirection
                forcedEnabledMode="true" [tabindex]="-1" (click)="eventMarkDirection_CLICKHandler()">
                <img src="{{kymw1400Model.srcMarkDirection}}">
              </button>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="hb_Page" class="block-row" style="height: 100%;" forcedEnabledMode="true">
    <app-kymw1400-koma-page-left id="pv_PageViewLeft" #pv_PageViewLeft forcedEnabledMode="true"
      [hidden]="!kymw1400Model.leftPageVisible"
      [style.width]="kymw1400Model.leftPageVisible && !kymw1400Model.rightPageVisible ? '100%' : '50%'">
    </app-kymw1400-koma-page-left>
    <app-kymw1400-koma-page-right id="pv_PageViewRight" #pv_PageViewRight forcedEnabledMode="true"
      [hidden]="!kymw1400Model.rightPageVisible"
      [style.width]="kymw1400Model.rightPageVisible && !kymw1400Model.leftPageVisible ? '100%' : '50%'">
    </app-kymw1400-koma-page-right>
  </div>
</div>